import { ensureNamespace } from '@/lib/i18n/runtime'
import { createFileRoute } from '@tanstack/react-router'
import { TeamsPage } from '@/features/teams/components/TeamsPage'

export const Route = createFileRoute('/_auth/teams')({
  beforeLoad: async () => { await Promise.all([ensureNamespace('shell'), ensureNamespace('teams')]).catch(() => { /* Boundary offers retry. */ }); },
  component: TeamsPage,
})
